import React from 'react'

const SarasRichText = (props) => {
    const {onChange , value, ...restProps} = props;
    const editorRef = React.useRef()

    const onTextChange = () => {
        if(onChange) onChange(editorRef,editorRef.current.value)
    }

    //Code to select text on focus
    // const onFocus = (e) => {
    //     if(editorRef.current)
    //     {
    //         console.log("SarasRichText");
    //         editorRef.current.select();
    //     }
    // }
    //onFocusCapture={onFocus}

    return(
        <textarea ref={editorRef} {...restProps} onBlur={onTextChange} defaultValue={value}>
            
        </textarea>
    )
    
}

export default SarasRichText